<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue';
export default {
  data () {
    return {
      cdata: {
        xData: ['找成果', '找服务', '找培训', '需求打听'],
        seriesData: [
          { value: 10, name: '找成果' },
          { value: 5, name: '找服务' },
          { value: 15, name: '找培训' },
          { value: 25, name: '需求打听' }
        ]
      }
    }
  },
  components: {
    Chart
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
